import { render } from "./TextArea.vue?vue&type=template&id=430744dd&scoped=true"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"

import "./TextArea.vue?vue&type=style&index=0&id=430744dd&scoped=true&lang=css"
import "./TextArea.vue?vue&type=style&index=1&id=430744dd&lang=scss&scoped=true"
import "@/assets/css/essayWriting.sass?vue&type=style&index=2&lang=sass"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430744dd"]])

export default __exports__